// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"976":"af8d951d","995":"33cb215e"}[chunkId] + ".chunk.css");